import styled from "styled-components";
import { Flex, Select } from "antd";
import { FilterControls } from "@/components/ListFilterBar/style";

export const MaterialSearchWrap = styled.div`
  width: 360px;
  max-width: 100%;
  flex-shrink: 0;
  margin-left: auto;

  ${FilterControls} {
    flex: 1;
  }
`;

export const RequiredItem = styled.span`
  color: #f00;
`

export const CellDisabled = styled.div`
  color: #999;
  cursor: not-allowed;
  text-align: left;
`
export const DescWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 16px; 
  width: 100%;
`

export const SelectWrap = styled(Select)`
  width: 100%;
  & .ant-select-selection-item{
    height: 26px !important;
  }
`

export const FlexWrap = styled(Flex)`
  width: 100%;
`

export const EditDataWrap = styled.div`
  width: 100%;
  height: 100%;
  .add-row {
    margin: 12px 0;
  }

  .material-search-row {
    margin-bottom: 8px;

    > .ant-form-item {
      flex: 1;
      min-width: 0;
      margin-bottom: 0;
    }
  }

  .content--wrap {
    max-height: 500px;
    min-height: 500px; 
    overflow-y: auto;
  }

  .htCore td,
  .htCore th {
    vertical-align: middle !important; /* 垂直居中 */
    text-align: center; /* 水平居中 */
  }
`

export const TitleWrap = styled.div`
  margin-bottom: 20px;

  .requirement--title {
    font-size: 18px;
    font-weight: 600;
  }
  & .ant-input {
    border: none;
   }
  & .ant-input-disabled{
    background-color: white !important;
    color: black;
    border: none;
  }
`

export const CreateNumWrap = styled.div`
  margin-top: 10px;
  color: rgba(0, 0, 0, 0.45);
`
